import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const SHORTCUTS: Array<{ keys: string[]; to: string }> = [
  { keys: ["g", "d"], to: "/" },
  { keys: ["g", "t"], to: "/time" },
  { keys: ["g", "p"], to: "/pto" },
  { keys: ["g", "c"], to: "/chat" },
  { keys: ["g", "s"], to: "/sops" },
  { keys: ["g", "h"], to: "/handbook" },
  { keys: ["g", "r"], to: "/documents" },
  { keys: ["g", "b"], to: "/tasks" },
  { keys: ["g", "u"], to: "/profile" },
];

export function useKeyboardShortcuts() {
  const nav = useNavigate();

  useEffect(() => {
    let buffer = "";
    let timer: ReturnType<typeof setTimeout> | null = null;

    function isEditable(target: EventTarget | null) {
      if (!target || !(target instanceof HTMLElement)) return false;
      const tag = target.tagName;
      return tag === "INPUT" || tag === "TEXTAREA" || tag === "SELECT" || target.isContentEditable;
    }

    function handler(e: KeyboardEvent) {
      if (e.metaKey || e.ctrlKey || e.altKey) return;
      if (isEditable(e.target)) return;
      // ? shows help — handled below
      if (e.key === "?") {
        e.preventDefault();
        document.dispatchEvent(new CustomEvent("scenta-shortcut-help"));
        return;
      }
      const k = e.key.toLowerCase();
      if (!/^[a-z]$/.test(k)) return;
      buffer += k;
      if (timer) clearTimeout(timer);
      timer = setTimeout(() => { buffer = ""; }, 800);

      for (const { keys, to } of SHORTCUTS) {
        if (buffer === keys.join("")) {
          buffer = "";
          if (timer) clearTimeout(timer);
          nav(to);
          return;
        }
      }
    }
    window.addEventListener("keydown", handler);
    return () => { window.removeEventListener("keydown", handler); if (timer) clearTimeout(timer); };
  }, [nav]);
}

export const SHORTCUT_LIST = SHORTCUTS;
